<template>
	<div class="content">
		<div class="container">
			<img :src="require(`@/assets/logo/logo-todomath-for-web-${$store.state.lang}@3x.png`)" class="center"/>
					<p v-html="l10.All_Footer_Title1">

					</p>
					<p  v-html="l10.All_Footer_Title1_Description1_Description1">

					</p>
			<div>
				<template v-if="isAndroid && this.$store.state.lang == 'cn' && this.$store.state.cnDownloadUrl != ''">
					<div id="mobile-store-btn" v-html="l10.All_Footer_Title2" @click="handleClickAndroidDownload"></div>
				</template>
				<template v-else>
					<a :href="downloadUrl" target="_blank">
						<div id="mobile-store-btn" :class="isAndroid ? 'mo_playstore_btn' : 'mo_appstore_btn'" v-html="l10.All_Footer_Title1"></div>
					</a>
				</template>
			</div>
		</div>

	</div>

</template>
<script>
import { isAndroid } from 'mobile-device-detect'

export default {
  name: 'TryTodomathBottom',
  props:[],
  data () {
	const text = require('@/text/common/footer.js').default;
	const l10n = text[this.$store.state.lang]?text[this.$store.state.lang]:text['en'];

	return {
		l10:l10n,
		downloadUrl:'',
		isAndroid: isAndroid
	}
	},
	created(){
		this.setDownloadUrl();
	},
	methods:{
		setDownloadUrl(){
			if (isAndroid) {
				if (this.$store.state.lang == 'cn' && this.$store.state.cnDownloadUrl != '') {
					this.downloadUrl = this.$store.state.cnDownloadUrl;
				} else {
					this.downloadUrl = this.$store.state.googlePlayUrl;
				}
			} else {
				this.downloadUrl = this.$store.state.appStoreUrl;
			}

			this.$emit('set-url', this.downloadUrl);

		},
		goToDownloadPage(){
			window.open(this.downloadUrl);
		},
		handleClickAndroidDownload() {
			this.$emit('click-cn-androiddownload')
		}
	}
}
</script>
<style  scoped>
.content{
	width:100%;
	overflow: hidden;
	background-image: url("../../assets/footer/img-main-try-bg-m.png");
	background-size:2400px auto;
	height:764px;
}

.container{
	margin: 0 auto;
	padding:0px 35px;
	padding-top:100px;
	height: auto;
	min-height: 100px;
	width:720px;
	display: flex;
	flex-direction: column;
	align-items: center;

}
.container>img{
	width: 239px;
  height: 180px;
  object-fit: contain;

}
.container>p:first-of-type{
	font-size: 64px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -3px;
  text-align: center;
  color: #41403e;

  margin-top:28px;
}
.container>p:last-of-type{
	margin-top:16px;
	font-size: 34px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.35;
  letter-spacing: -1px;
  text-align: center;
  color: #41403e;

  margin-bottom: 84px;
}
.container>div{
	width: 100%;

}
#mobile-store-btn{
	width: 100%;
	height: 104px;
	font-size: 34px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 100px;
	letter-spacing: -1px;
	text-align: center;
	color: #41403e;
	border-radius: 10px;
	border: solid 3px #41403e;
	cursor: pointer;

}

</style>



// WEBPACK FOOTER //
// src/components/footer/TryTodomathMobile.vue